module.exports = __webpack_public_path__ + "static/media/graphql.e4b4d327.png";